import React from 'react';
import { number, arrayOf, shape, string } from 'prop-types';
import { ListTile } from '@thd-olt-component-react/list-tile';

const ListsCompactList = ({ lists, maxMobileListSize }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-2 sui-mb-8">
      {lists?.slice(0, maxMobileListSize).map((list, index) => (
        <ListTile
          iconSize="small"
          key={index + list.id}
          listId={list.id}
          data={list}
          useLatestDesign
          numberOfThumbnails={3}
          position={index}
        />
      ))}
    </div>
  );
};

ListsCompactList.propTypes = {
  maxMobileListSize: number,
  lists: arrayOf(shape({
    id: string,
    name: string,
    url: string,
    itemCount: number,
    listAccessType: string,
    images: arrayOf(shape({
      url: string
    }))
  })),
};

ListsCompactList.defaultProps = {
  maxMobileListSize: 4,
  lists: [],
};

export default ListsCompactList;
